










import { Component, Vue } from 'vue-property-decorator';

import RelatedArticlesItem from './relatedArticlesItem.vue';

@Component({
  components: {
    RelatedArticlesItem,
  },
})
export default class RelatedArticlesComponent extends Vue {
}
